import { prefixPath } from '@/config'

export default function () {
  return [
    {
      title: '姓名',
      [$field]: 'userName'
    },
    {
      title: '工号',
      [$field]: 'userCode'
    },
    {
      title: '性别',
      [$field]: 'gender',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['DM14'].map(item => {
          if (row.gender == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '政治面貌',
      [$field]: 'political',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['GB4762'].map(item => {
          if (row.political == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '学历',
      [$field]: 'education',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['DM16'].map(item => {
          if (row.education == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '工作地',
      [$field]: 'workPlace'
    },
    {
      title: '行政职务',
      [$field]: 'hrDuty',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['KZ27'].map(item => {
          if (row.hrDuty == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '是否有廉洁问题',
      [$field]: 'hasHonestTaint',
      render: (h, {row, index}) => {
        let radioOptionList = {
          1: '是',
          2: '否'
        }
        return h('span', radioOptionList[row.hasHonestTaint])
      }
    },
    {
      title: '廉洁问题类型',
      [$field]: 'honestType',
      render: (h, {row, index}) => {
        let edit
        this.dictMap['BOE51'].map(item => {
          if (row.honestType == item.value) {
            edit = item.label
          }
        })
        return h('div', [edit])
      }
    },
    {
      title: '廉洁证明状态',
      [$field]: 'certificateState',
      render: (h, {row}) => {
        if (!row.certificateState) {
          return h('div', '未生成')
        } else {
          return h('span', {
            class: 'iv-pointer iv-hover-color iv-m-b-12 iv-main-color',
            on: {
              'click': function () {
                let url = `${prefixPath}honest/certificate/download?certificateUserId=${row.certificateUserId}` + '&access_token=' + sessionStorage.getItem('token') + '&currentAuthScopeId=' + sessionStorage.getItem('listOrgId')
                window.open(url)
              }
            }
          }, '廉洁证明附件.doc')
        }
      }
    }
  ]
}
